module.exports = __webpack_public_path__ + "img/img_ serve2.531114d4.png";